import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import apiInstance from "../apiConfig/apiinstance";
import { TokenManager } from "../apiConfig/apiinstance";

const Sidebar = ({ mainLoading, currentPage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const currentCategory = searchParams.get("category");
  const [categories, setCategories] = useState([]);
  // const [msrCategories, setMSRCategories] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // const isApparel = searchParams.get("view") === "apparel";
  const isApparel = true;

  const [token, setToken] = useState(TokenManager.getAccessToken());

  const pathSegments = location.pathname.split("/");
  const categoryFromPath =
    pathSegments[1] === "filter-product" || pathSegments[1] === "tag"
      ? pathSegments[2]
      : pathSegments[1];

  // console.log("categoryFromPath", categoryFromPath);

  const fetchCategories = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await apiInstance.get(`/api/cat/v1/parent-categories/`);
      if (data.status === 200) {
        if (!data?.data?.length) {
          // setError("No categories found");
          setCategories([]);
        } else {
          setCategories(data.data);
        }
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Error fetching categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem("token"));
    };

    // Listen for localStorage changes
    window.addEventListener("storage", handleStorageChange);

    // Also listen for custom events (for same-tab updates)
    window.addEventListener("tokenUpdated", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("tokenUpdated", handleStorageChange);
    };
  }, []);

  const handleCategoryClick = (slug) => {
    navigate(
      `/filter-product/${slug}?view=apparel&&currentPage=${currentPage ?? 1}`
    );
  };

  const handleApparelClick = () => {
    if (categories.length > 0) {
      handleCategoryClick(categories[0].slug);
    }
  };

  const isCategoryActive = (itemSlug) => {
    // Check both URL parameter and path segment
    return currentCategory === itemSlug || categoryFromPath === itemSlug;
  };

  return (
    <div className="sidebar ">
      {loading ? (
        <div className="loader-container">
          <ClipLoader size={20} color="#999" />
        </div>
      ) : error ? (
        <h2
          className="loader-container"
          style={{ color: "red", textAlign: "center" }}
        >
          {error}
        </h2>
      ) : (
        <>
          {isApparel && (
            <ul className="nav-links border-b-2 pb-3 border-gray-800">
              {categories.map((item) => (
                <li key={item.cat_id}>
                  <a
                    className={`cursor-pointer ${
                      isCategoryActive(item.slug) ? "active" : ""
                    } ${mainLoading ? "pointer-events-none opacity-50" : ""}`}
                    onClick={() => {
                      if (!loading) {
                        handleCategoryClick(item.slug);
                      }
                    }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
              <hr className="my-3" />
              {["print", "embroidery", "lace", "pintuck"].map((item) => (
                <li key={item}>
                  <a
                    className={`cursor-pointer ${
                      isCategoryActive(item) ? "active" : ""
                    } ${mainLoading ? "pointer-events-none opacity-50" : ""}`}
                    onClick={() => {
                      if (!loading) {
                        // if (item === "lace/pintuck") {
                        //   navigate(`/tagfolderdivison?view=apparel`);
                        // } else {
                        navigate(`/tag/${item}?view=apparel`);
                        // }
                      }
                    }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          )}
          <ul className="nav-links mt-2">
            {!isApparel && token && (
              <li className={`${categories.length > 0 ? "" : "text-gray-400"}`}>
                <a onClick={handleApparelClick}>Clothing</a>
              </li>
            )}

            {token && (
              <li className="pt-3 border-gray-800">
                <a onClick={() => navigate("/wishlist")}>Go To Likes</a>
              </li>
            )}
          </ul>
        </>
      )}
    </div>
  );
};

export default Sidebar;
